import { caretWhite, iconSearchBlue } from "@common/_assets/images";
import { FormInput, spreadAndtransformDefaultValues } from '@common/components/forms';
import { useRecentClientSearch } from "@common/hooks/useRecentClients";
import { UserService } from "@common/services/userService";
import { ClientSearchStore, IClientSearchFilter, defaultClientSearchFilter } from "@common/stores";
import { observer } from "mobx-react";
import React, { useRef, useState } from 'react';
import { Form, Image, InputGroup, Overlay, Popover } from "react-bootstrap";
import { useForm } from 'react-hook-form';
import { usePromiseTracker } from "react-promise-tracker";
import { useNavigate } from "react-router";
import { NavLink, useParams } from 'react-router-dom';

type IClientSearchButtonProps = {
	store: ClientSearchStore
	isCsr?: boolean;
}

const defaultValues = { phone: "" }

export const ClientSearchButton = observer(({ store, isCsr = false }: IClientSearchButtonProps) => {
	const { promiseInProgress } = usePromiseTracker({
		delay: 500,
		area: UserService.tags.getRecentClients,
	});
	const { hospitalId } = useParams();
	const navigate = useNavigate();
	const { handleSubmit, reset, control } = useForm<IClientSearchFilter>();
	const recentClientStore = useRecentClientSearch();
	const onSubmit = (data: IClientSearchFilter) => {
		// push the phone number (if any) to the client search store
		store.updateSearchFilter({
			...defaultClientSearchFilter,
			phone: data.phone
		});
		// clear out the search box
		reset(spreadAndtransformDefaultValues(defaultValues));
		// navigate to this hospital's clients page to show the search results.
		if (isCsr) {
			store.triggerDisclaimer();
			navigate('/');
		}
		else {
			navigate(`/${hospitalId}/clients`);
		}
	}
	// Used to show / hide overlay.
	const [show, setShow] = useState(false);
	const target = useRef(null);
	// Used to limit number of network requests.
	const previousClickedRecentHistory = useRef(0);
	const showOverlay = () => {
		setShow(!show);
		// Ref gets reset to zero every page load.
		if (previousClickedRecentHistory.current === 0) {
			recentClientStore.getRecentlyViewedClients();
		}
		previousClickedRecentHistory.current = previousClickedRecentHistory.current + 1;
	};
	const lastFiveRecentClients = recentClientStore?.recentClients?.filter((_, index) => index < 5) ?? [];
	return (
		<Form className="d-flex" onSubmit={handleSubmit(onSubmit)}>
			<div>
				<InputGroup style={{ width: '190px' }}>
					<FormInput type="tel" controlId="phone" className="rounded-search" label="" fieldName="phone" control={control} placeholder="Client phone number" />
					<span className="searchIcon cursor-pointer" onClick={handleSubmit(onSubmit)} />
				</InputGroup>
			</div>
			<div className="d-flex w-100" ref={target}>
				<span

					style={{ color: 'white', alignSelf: 'center', minWidth: '150px' }}
					className="w-100"
				>
					<span>&nbsp;&nbsp;|&nbsp; &nbsp;</span>
					<span className="cursor-pointer" onClick={() => showOverlay()}>
						Recent clients&nbsp; &nbsp;
						<Image className={''} alt={'caret'} src={caretWhite} />
					</span>
				</span>
			</div>
			<Overlay
				show={show}
				target={target.current}
				placement="bottom"
				container={target}
				rootClose
				onHide={() => setShow(false)}
			>
				<Popover id="popover-contained">
					<Popover.Body>
						<div className="profile-nav">
							{promiseInProgress ? <LoadingOverlay /> : undefined}
							{lastFiveRecentClients.map((recentClient, index) => {
								return <div key={`${index}-recent-client`} className="p-3 w-100 border-bottom-gray">
									{
										isCsr
											? <NavLink className="text-decoration-none" to={`/clients/${recentClient.ClientId}`} target="_blank" >
												{`${recentClient.FirstName} ${recentClient.LastName}`}
											</NavLink>
											: <NavLink className="text-decoration-none" to={`/${hospitalId}/clients/${recentClient.ClientId}`} >
												{`${recentClient.FirstName} ${recentClient.LastName}`}
											</NavLink>
									}
								</div>
							})}
							<div className="py-3 w-100 border-bottom-gray fw-bold" style={{ color: '#001952' }}>
								<NavLink onClick={() => setShow(false)} className="text-decoration-none" to={isCsr ? '/clients' : `/${hospitalId}/clients/`} >
									<Image className={''} alt={'caret'} src={iconSearchBlue} />
									Search More Clients
								</NavLink>
							</div>
						</div>
					</Popover.Body>
				</Popover>
			</Overlay>
		</Form >
	)
});

const LoadingOverlay = () => <>
	<div className="p-3 w-100 border-bottom-gray fw-bold" style={{ height: 200 }}>Loading Recent Clients ... </div>
</>

export default ClientSearchButton
